export function workorderStatusLabel(status: number, t?: any) {
  switch (status) {
    case 1:
      return t("global.new", "New")
    case 2:
      return t("global.send", "Send")
    case 3:
      return t("global.ongoing", "Ongoing")
    case 4:
      return t("global.fixed", "Fixed")
    case 5:
      return t("global.completed", "Completed")
    case 6:
      return t("global.cancelled", "Cancelled")
    default:
      return "-"
  }
}
